import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';

const DescriptionEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ description: event.target.value }));
  };

  return (
    <TextField
      label="Description"
      size="small"
      fullWidth
      value={currentAsset?.description || ''}
      onChange={handleChange}
    />
  );
};

export default DescriptionEdit;
